module.exports = {
      id: "energy-usage",
      viewBox: "0 0 14.8 21.3",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#energy-usage",
      toString: function () {
        return this.url;
      }
    }